import qs from 'querystring';
import 'abort-controller/polyfill';
import 'isomorphic-unfetch';
import retry from 'promise-retry';
import * as R from 'ramda';

// import

function _catch(body, recover) {
  try {
    var result = body();
  } catch (e) {
    return recover(e);
  }

  if (result && result.then) {
    return result.then(void 0, recover);
  }

  return result;
}

const retryDefs = {
  retries: 0,
  factor: 1.5,
  minTimeout: 500,
  maxTimeout: Infinity,
  randomize: false
};
const endSlashRx = /\/$/;
const startSlashRx = /^\//; // fns

const nil = () => null;

const mergeRequestOpts = (pathOrOpts, maybeOpts) => typeof pathOrOpts === 'string' ? {
  path: pathOrOpts,
  ...maybeOpts
} : pathOrOpts;
const createRetryAdaptor = (retryOpts = {}) => function (fetcher) {
  try {
    return Promise.resolve(retry(function (retryFn) {
      try {
        return Promise.resolve(fetcher().catch(retryFn));
      } catch (e) {
        return Promise.reject(e);
      }
    }, { ...retryDefs,
      ...retryOpts
    }));
  } catch (e) {
    return Promise.reject(e);
  }
}; // export

function createRequest(defs = {}) {
  const request = function (pathOrOpts, maybeOpts) {
    try {
      const opts = mergeRequestOpts(pathOrOpts, maybeOpts);
      const {
        baseUrl,
        path,
        query,
        body,
        headers,
        useJson = false,
        useCors = false,
        sameOrigin = false,
        response: responseType = 'json',
        onlyBody = false,
        timeout = 0,
        adaptors,
        ...rest
      } = R.mergeDeepRight(defs, opts);
      const realAdaptors = (Array.isArray(adaptors) ? adaptors : adaptors ? [adaptors] : []).filter(Boolean);
      const reqUrl = [...(baseUrl ? [baseUrl.replace(endSlashRx, ''), '/'] : []), path == null ? void 0 : path.replace(startSlashRx, ''), ...(query ? ['?', qs.stringify(query)] : [])].join('');
      const reqOpts = {
        method: body ? 'POST' : 'GET',
        body: body ? useJson ? JSON.stringify(body) : body : undefined,
        mode: sameOrigin ? 'same-origin' : useCors ? 'cors' : 'no-cors',
        credentials: sameOrigin ? 'same-origin' : useCors ? 'omit' : 'include',
        ...rest,
        headers: { ...(useJson ? {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          } : {}),
          ...(useCors ? {
            'Access-Control-Allow-Origin': '*'
          } : {}),
          ...(R.is(String, sameOrigin) ? {
            'Access-Control-Allow-Origin': sameOrigin
          } : {}),
          ...headers
        }
      };

      const fetcher = function () {
        try {
          let ctrl = null;

          if (timeout) {
            ctrl = new AbortController();
            setTimeout(() => {
              var _ctrl;

              return (_ctrl = ctrl) == null ? void 0 : _ctrl.abort();
            }, timeout);
          }

          const theseOpts = ctrl ? { ...reqOpts,
            signal: ctrl.signal
          } : reqOpts;
          return Promise.resolve(fetch(reqUrl, theseOpts)).then(function (res) {
            return Promise.resolve(res[responseType]().catch(nil)).then(function (parsedBody) {
              const response = {
                status: res.status,
                headers: res.headers,
                body: parsedBody
              };

              if (!res.ok) {
                var _parsedBody$message;

                const err = new Error((_parsedBody$message = parsedBody == null ? void 0 : parsedBody.message) != null ? _parsedBody$message : `${res.status} ${res.statusText}`);
                err.body = parsedBody;
                err.response = response;
                throw err;
              }

              return onlyBody ? parsedBody : response;
            });
          });
        } catch (e) {
          return Promise.reject(e);
        }
      };

      return Promise.resolve(_catch(function () {
        return Promise.resolve(realAdaptors.reduce((f, adaptor) => {
          return function () {
            try {
              return Promise.resolve(adaptor(f));
            } catch (e) {
              return Promise.reject(e);
            }
          };
        }, fetcher)());
      }, function (err) {
        err.url = reqUrl;
        err.request = reqOpts;
        throw err;
      }));
    } catch (e) {
      return Promise.reject(e);
    }
  };

  request.extend = (newDefs = {}) => createRequest(R.mergeDeepRight(defs, newDefs));

  return request;
}
const request = createRequest();

export { createRequest, createRetryAdaptor, mergeRequestOpts, request };
//# sourceMappingURL=index.module.js.map
